const colors = {
  btn: {
    primary: {
      normal: {
        fg: "rgb(0,0,0)",
        bg: "rgb(240, 193, 75)",
      },
      hover: {
        fg: "rgb(0,0,0)",
        bg: "rgb(168, 139, 64)",
      },
    },
    secondary: {
      normal: {
        fg: "rgb(255, 255, 255)",
        bg: "rgb(177, 39, 4)",
      },
      hover: {
        fg: "rgb(0,0,0)",
        bg: "rgb(168, 139, 64)",
      },
    },
  },
  grey: {
    sm: "rgb(221, 221, 221)",
    md: "rgb(187, 187, 187)",
    lg: "rgb(242, 242, 242)",
  },
};

export default colors;
